/**
 * ชุดเซ็ต (PLAN ขั้นที่ 3.5)
 *
 * - ข้อมูลอยู่ที่ `data/sets.json` ที่เดียว (ชิ้นที่ร่วม โบนัสตามจำนวนชิ้น โบนัสตีบวกร่วมเซ็ต)
 *   **ไอเทมไม่ได้เก็บว่าตัวเองอยู่เซ็ตไหน** ถามผ่าน `setOfItem` เพื่อไม่ให้ข้อมูลสองที่ขัดกัน
 * - โบนัสเป็น `CardBonus` (ฟิลด์เดิม + skillMods) รวมเข้าค่ารองผ่าน `addCardBonus` ที่เดียวกับการ์ด
 * - **โบนัสตีบวกร่วมเซ็ต** ต้องสวมครบทุกชิ้น และนับจากระดับตีบวกต่ำสุดในชุด
 * - คิดจากของที่สวม + ระดับตีบวกที่มีอยู่แล้ว ไม่ต้องเก็บอะไรเพิ่มในฐานข้อมูล
 *
 * pure function ทั้งหมด
 */
import setsJson from "./data/sets.json" with { type: "json" };
import { mapEntries, readMap } from "./equip.js";
export const SET_LIST = setsJson;
export const SETS = Object.freeze(Object.fromEntries(SET_LIST.map((s) => [s.id, s])));
const PIECE_TO_SET = new Map(SET_LIST.flatMap((s) => s.pieces.map((id) => [id, s])));
/** เซ็ตที่ไอเทมนี้อยู่ ไม่มี = undefined */
export function setOfItem(itemId) {
    return PIECE_TO_SET.get(itemId);
}
/**
 * ความคืบหน้าของทุกเซ็ตที่สวมอยู่อย่างน้อยหนึ่งชิ้น
 * ชิ้นเดียวกันสวมสองช่อง (ต่างหู) นับครั้งเดียว
 */
export function setProgress(equipped, refines) {
    const bySet = new Map();
    for (const [slot, itemId] of mapEntries(equipped)) {
        const set = itemId ? setOfItem(itemId) : undefined;
        if (!set)
            continue;
        const e = bySet.get(set.id) ?? { set, worn: new Set(), minRefine: Infinity };
        e.worn.add(itemId);
        e.minRefine = Math.min(e.minRefine, refines ? Number(readMap(refines, slot) ?? 0) : 0);
        bySet.set(set.id, e);
    }
    return [...bySet.values()].map(({ set, worn, minRefine }) => {
        const n = worn.size;
        const full = n >= set.pieces.length;
        const minR = full && Number.isFinite(minRefine) ? minRefine : 0;
        return {
            set,
            worn: [...worn],
            active: set.bonuses.filter((b) => n >= b.count).map((b) => b.bonus),
            minRefine: minR,
            refineActive: full ? (set.refineBonuses ?? []).filter((b) => minR >= b.minRefine).map((b) => b.bonus) : [],
        };
    });
}
/** โบนัสเซ็ตทั้งหมดที่ติดอยู่ เป็นรายการ CardBonus ให้รวมด้วย `addCardBonus` */
export function activeSetBonuses(equipped, refines) {
    return setProgress(equipped, refines).flatMap((p) => [...p.active, ...p.refineActive]);
}
//# sourceMappingURL=sets.js.map